require('jquery')
require('angular')
# bootstrap-alert - report description
require('bootstrap-alert')
require('bootstrap-collapse')
require('bootstrap-dropdown')
require('bootstrap-modal')
# bootstrap-tab - old cohort builder
require('bootstrap-tab')
require('bootstrap-tooltip')
# bootstrap-popover - is using in tours and should be required after bootstrap-tooltip
require('bootstrap-popover')
# bootstrap-transition - animation for modal windows
require('bootstrap-transition')
#moment needs to be global for angular-moment-picker to work
window.moment = require('moment')
require('select2');
require('error-types')
require('date')
require('datatables')
require('dataTablesSource')
require('dt-diacritics')
require('dt-tools')
require('dt-fixed-columns')
require('dt-scroller')
require('bootstrap-picker')
require('angular-moment-picker')
require('jquery-cookie')
require('jquery-ui')
require('jquery-ui-widget')
require('jquery-ui-mouse')
require('jquery-ui-sortable')
require('codemirror')
require('codemirror-mysql')
require('bootstrap-tour')
require('angular-sanitize')
require('angular-route')
require('angular-messages')
require('angular-resource')
require('angular-md5')
require('model-factory')
require('angular-cache')
require('angular-ui')
require('angular-strap')
require('angular-gridster')
window._ = require('underscore')
require('shim-cohort-builder')
require('rjmUI')
require('sequence-string-parser')
# Hack for old cohort builder page
window.Highcharts = require('highcharts')
require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/funnel')(Highcharts)
require('highcharts/modules/heatmap')(Highcharts)
require('highcharts/highcharts-more')(Highcharts)
require('highcharts-theme')

Highcharts.setOptions(Highcharts.light)

require('./rjmNgModules.coffee')

require('./**/*.coffee', {
  mode: 'expand'
  options:
    ignore: './**/*Spec.coffee'
})
require('./**/*.js', {
  mode: 'expand'
})

require('./thirdParty')

angular.bootstrap(window.document, ['rjmNg'])

